"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var ko = require("knockout");
var $ = require("jquery");
var validatedViewModel_1 = require("../viewModels/base/validatedViewModel");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var dateTimeUtils_1 = require("../utils/dateTimeUtils");
var ModerateCommentComponent = (function (_super) {
    __extends(ModerateCommentComponent, _super);
    function ModerateCommentComponent(params, element, templateNodes) {
        _super.call(this, params);
        this.targetId = ko.observable();
        this.isModerator = ko.observable(false);
        this.removalReasonComment = ko.observable("");
        this.removeAndHide = ko.observable("");
        this.removalReasons = [
            "Оскорбление пользователя",
            "Провокация конфликта",
            "Спам",
            "Нарушение правил",
            "Остальное"
        ];
        this.selectedReason = ko.observable().extend({
            required: {
                params: true,
                message: "Пожалуйста, укажите причину удаления."
            }
        });
        $(element).appendTo(document.body);
        this.params = params;
        this.element = element;
        this.templateNodes = templateNodes;
    }
    ModerateCommentComponent.prototype.showEdit = function (commentId, selectedReason, removalReason) {
        var _this = this;
        this.errorMessages([]);
        this.targetId(commentId);
        this.isModerator(true);
        this.selectedReason(selectedReason);
        this.removalReasonComment(removalReason);
        setTimeout(function () {
            if (_this.validation === undefined) {
                _this.initValidation();
            }
        }, 0);
        app.closeModal();
        app.f7.pickerModal(document.getElementById("mobileModerate"));
    };
    ModerateCommentComponent.prototype.show = function (commentId, isModerator) {
        var _this = this;
        this.errorMessages([]);
        this.targetId(commentId);
        this.isModerator(isModerator);
        if (this.selectedReason()) {
            this.selectedReason(null);
        }
        if (this.removalReasonComment()) {
            this.removalReasonComment("");
        }
        setTimeout(function () {
            if (_this.validation === undefined) {
                _this.initValidation();
            }
        }, 0);
        app.closeModal();
        app.f7.pickerModal(document.getElementById("mobileModerate"));
    };
    ModerateCommentComponent.prototype.submit = function () {
        var _this = this;
        if (this.validation !== undefined && !this.validation.isValid()) {
            this.validation.errors.showAllMessages();
            return;
        }
        this.processing(true);
        this.errorMessages([]);
        var data = {
            id: this.targetId(),
            removalReason: this.selectedReason(),
            removalReasonComment: this.removalReasonComment(),
            removeAndHide: this.removeAndHide()
        };
        ajaxUtils_1.AjaxUtils.post("comment/delete", data)
            .done(function (result) {
            if (result.isSuccessful) {
                if (result.data.isReload) {
                    ModerateCommentComponent.reloadComments();
                }
                else {
                    var commentId = "#comment_" + _this.targetId();
                    var $target = $(commentId);
                    var $html = $(result.data.html);
                    if (_this.removeAndHide()) {
                        var repliesComment = $target.siblings(".comment, .comment-toggle, .replies");
                        repliesComment.replaceWith($html);
                    }
                    else {
                        var $comment = $target.siblings(".comment");
                        $comment.replaceWith($html);
                    }
                    dateTimeUtils_1.default.displayTime($html);
                }
                var modal = document.getElementById("mobileModerate");
                if (modal) {
                    app.f7.closeModal(modal);
                }
            }
            else {
                _this.errorMessages(result.messages);
            }
        }).always(function () {
            _this.processing(false);
        });
    };
    ModerateCommentComponent.reloadComments = function () {
        window.location.reload();
    };
    return ModerateCommentComponent;
}(validatedViewModel_1.default));
ko.components.register("mobile-moderate-comment-form", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = ModerateCommentComponent;
//# sourceMappingURL=mobileModerateCommentForm.js.map